import { authAxiosClient } from '@/lib';
import { Nullable, PaginatedApiResponse, PaginatedData } from '@/types';
import { withLogger } from '@/utils';

import { usersAPIUrls } from '../data';
import { RecentActivity } from '../types';

type Param = {
  userId: Nullable<Nullable<string> | undefined>;
};

type RecentActivities = Array<RecentActivity>;
type Return = PaginatedData<Array<RecentActivity>>;

export type GetRecentActivity = {
  param: Param;
  return: Return;
};

export const getRecentActivity = withLogger(
  async ({ userId }: Param): Promise<Return> => {
    const {
      data: { data },
    } = await authAxiosClient.get<PaginatedApiResponse<RecentActivities>>(
      `${usersAPIUrls.getUser}/${userId}/credit`,
    );
    return data;
  },
);
